module.exports = __webpack_public_path__ + "static/media/Colette Wing Super King Headboard - 200 cm_Black.6c660cd7.png";